import axios from 'axios'

export default {
  export: async (sitePath, id) => {
    const url = `${sitePath}/exportimport/export_site/`;

    const response = await axios.get(url);

    return response.data
  },

  import: async (sitePath, formdata) => {
    const url = `${sitePath}/exportimport/import_site/`;

    const response = await axios.post(url,formdata);

    return response.data;
  },

  exportExcel: async (sitePath, id, formdata) => {
    const url = `${sitePath}/site-config/export/`;
    let obj = {};

    if (formdata === undefined) {
      formdata = new FormData();
    }

    const response = await axios.get(url, {
      responseType: 'arraybuffer',
      params: {
        sheets: obj['sheets'],
      },
    });

    return response
  },

  getAvailableSheets: async (sitePath) => {
    const url = `${sitePath}/site-config/export/available-sheets/`;
    const response = await axios.get(url);
    return response.data
  },

  importExcelDryRun: async (sitePath, formdata, dryRun) => {
    const url = `${sitePath}/site-config/import/dry-run/`;
    const response = await axios.post(url,formdata);
    return response.data;
  },

  importExcelPersist: async (sitePath, formdata) => {
    const url = `${sitePath}/site-config/import/persist/`;
    const response = await axios.post(url,formdata);
    return response.data;
  },
}
